import * as z from "zod";
//#region src/__generated__/filesystem-gge/pdfDocument/zod/abstractDeleteResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const abstractDeleteResponseSchema = z.object({ filename: z.string().nullish() });
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/delete3Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const delete3PathIdSchema = z.uuid();
const delete3Status200Schema = z.array(abstractDeleteResponseSchema);
const delete3ResponseSchema = delete3Status200Schema;
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/deleteFileMetasRequestDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const deleteFileMetasRequestDtoSchema = z.object({
	ids: z.array(z.uuid()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }),
	initUserId: z.uuid()
});
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/deleteMany3Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const deleteMany3Status200Schema = z.array(z.string());
const deleteMany3ResponseSchema = deleteMany3Status200Schema;
const deleteMany3DataSchema = deleteFileMetasRequestDtoSchema;
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/pdfCropBoxDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const pdfCropBoxDtoSchema = z.object({
	height: z.number().nullish().describe("Высота CropBox").meta({ examples: [841.92] }),
	width: z.number().nullish().describe("Ширина CropBox").meta({ examples: [595.32] }),
	x: z.number().nullish().describe("X координата нижнего левого угла CropBox").meta({ examples: [0] }),
	y: z.number().nullish().describe("Y координата нижнего левого угла CropBox").meta({ examples: [0] })
}).describe("Границы CropBox страницы PDF в PDF points");
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/getCropBoxSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getCropBoxPathFileIdSchema = z.uuid();
const getCropBoxQueryPageSchema = z.int();
const getCropBoxStatus200Schema = pdfCropBoxDtoSchema.describe("Границы CropBox страницы PDF в PDF points");
const getCropBoxResponseSchema = getCropBoxStatus200Schema;
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/fileMetaDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const fileMetaDtoSchema = z.object({
	author: z.uuid(),
	baseName: z.string(),
	createdAt: z.union([z.number(), z.iso.datetime()]),
	ext: z.string().nullish(),
	id: z.uuid(),
	isDeleted: z.boolean(),
	modifiedAt: z.union([z.number(), z.iso.datetime()]),
	parentId: z.uuid().nullish(),
	preview: z.string().nullish().describe("Файл preview закодированный в base64. Поле может быть null, если для данного элемента не поддерживаются preview либо, если для данного элемента preview еще не было получено/сконвертировано."),
	previewId: z.uuid().nullish(),
	size: z.int(),
	sourceId: z.uuid(),
	sourceType: z.enum([
		"PROJECT_ID",
		"WORK_GROUP",
		"MODEL_REPOSITORY",
		"CONTRACTOR_MANAGEMENT",
		"COSMOS",
		"COSMOS_FOR_DELETE",
		"COSMOS_FOR_MIGRATE",
		"ONTOLOGY_FILE_UPLOAD",
		"CLASSIFIER_TABLE_ROW",
		"ONTOLOGY_CLASSIFIER_TABLE",
		"ONTOLOGY_CATALOG_DEFINITION",
		"ONTOLOGY_SFO_DEFINITION",
		"MODEL_PROPERTIES",
		"KNOWLEDGE_BASE",
		"REPORT_GENERATION_CACHE"
	]),
	type: z.enum([
		"DIRECTORY",
		"DOCUMENT",
		"CLASSIFIER_DOCUMENT",
		"MODEL",
		"MODEL_DATA",
		"MODEL_DATA_SIMPLIFIED",
		"IMAGE",
		"COMMENT_DOCUMENT",
		"COSMOS_DOCUMENT",
		"COSMOS_GEOSERVER_DOCUMENT",
		"BUILDING_MANAGEMENT_DOCUMENT",
		"TASK_TRACKER",
		"MODEL_REPOSITORY",
		"CONTRACTOR_MANAGEMENT",
		"ONTOLOGY_DOCUMENT",
		"COLLISION_DOCUMENT",
		"KNOWLEDGE_BASE_DOCUMENT",
		"REPORT_GENERATION_CACHE",
		"PDF_DOCUMENT",
		"PDF_DOCUMENT_PREVIEW"
	]),
	version: z.int(),
	versionParentId: z.uuid().nullish().describe("Id первой версии этого файла. Присутствует только если поле version > 1")
});
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/getFileMetasRequestDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getFileMetasRequestDtoSchema = z.object({ ids: z.array(z.uuid()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }) });
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/getFileMetas3Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getFileMetas3Status200Schema = z.array(fileMetaDtoSchema);
const getFileMetas3ResponseSchema = getFileMetas3Status200Schema;
const getFileMetas3DataSchema = getFileMetasRequestDtoSchema;
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/pdfAreaRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const pdfAreaRequestSchema = z.object({
	areaHeight: z.number().optional(),
	areaWidth: z.number().optional(),
	originX: z.number().optional(),
	originY: z.number().optional(),
	page: z.int().optional(),
	rotation: z.enum([
		"DEG_0",
		"DEG_90",
		"DEG_180",
		"DEG_270"
	]).describe("Drawing page rotation")
});
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/getHighlightedAreaAsImageSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getHighlightedAreaAsImagePathFileIdSchema = z.uuid();
const getHighlightedAreaAsImageStatus200Schema = z.array(z.object({
	char: z.string().optional(),
	direct: z.boolean().optional(),
	double: z.number().optional(),
	float: z.number().optional(),
	int: z.int().optional(),
	long: z.int().optional(),
	readOnly: z.boolean().optional(),
	short: z.int().optional()
}));
const getHighlightedAreaAsImageResponseSchema = getHighlightedAreaAsImageStatus200Schema;
const getHighlightedAreaAsImageDataSchema = pdfAreaRequestSchema;
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/getHighlightedAreaAsPdfSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getHighlightedAreaAsPdfPathFileIdSchema = z.uuid();
const getHighlightedAreaAsPdfStatus200Schema = z.array(z.object({
	char: z.string().optional(),
	direct: z.boolean().optional(),
	double: z.number().optional(),
	float: z.number().optional(),
	int: z.int().optional(),
	long: z.int().optional(),
	readOnly: z.boolean().optional(),
	short: z.int().optional()
}));
const getHighlightedAreaAsPdfResponseSchema = getHighlightedAreaAsPdfStatus200Schema;
const getHighlightedAreaAsPdfDataSchema = pdfAreaRequestSchema;
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/getLatestFileMetasRequestDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getLatestFileMetasRequestDtoSchema = z.object({ ids: z.array(z.uuid()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }) });
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/getLatestFileMetas3Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getLatestFileMetas3Status200Schema = z.array(fileMetaDtoSchema);
const getLatestFileMetas3ResponseSchema = getLatestFileMetas3Status200Schema;
const getLatestFileMetas3DataSchema = getLatestFileMetasRequestDtoSchema;
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/pdfMetaResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const pdfMetaResponseSchema = z.object({
	fileId: z.uuid().nullish(),
	pageCount: z.int().nullish()
});
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/getPageCountSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getPageCountQueryFileIdSchema = z.array(z.uuid());
const getPageCountStatus200Schema = z.array(pdfMetaResponseSchema);
const getPageCountResponseSchema = getPageCountStatus200Schema;
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/pdfPreviewRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const pdfPreviewRequestSchema = z.object({ pages: z.array(z.int()).optional() });
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/pdfPreviewItemSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const pdfPreviewItemSchema = z.object({
	content: z.string().nullish(),
	page: z.int().nullish()
});
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/pdfPreviewResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const pdfPreviewResponseSchema = z.object({
	fileId: z.uuid().nullish(),
	pageCount: z.int().nullish(),
	previews: z.array(pdfPreviewItemSchema).nullish()
});
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/getPreviewsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getPreviewsPathFileIdSchema = z.uuid();
const getPreviewsStatus200Schema = pdfPreviewResponseSchema;
const getPreviewsResponseSchema = getPreviewsStatus200Schema;
const getPreviewsDataSchema = pdfPreviewRequestSchema;
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/pdfDocumentListResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const pdfDocumentListResponseSchema = z.object({ fileMeta: z.union([fileMetaDtoSchema, z.null()]).optional() });
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/list3Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const list3PathIdSchema = z.uuid();
const list3Status200Schema = z.array(pdfDocumentListResponseSchema);
const list3ResponseSchema = list3Status200Schema;
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/fileMoveDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const fileMoveDtoSchema = z.object({
	id: z.uuid(),
	parentId: z.uuid()
}).describe("Move модель для файла.");
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/pdfDocumentMoveResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const pdfDocumentMoveResponseSchema = z.object({ moveCnt: z.int().nullish() });
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/move2Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const move2Status200Schema = z.array(pdfDocumentMoveResponseSchema);
const move2ResponseSchema = move2Status200Schema;
const move2DataSchema = fileMoveDtoSchema.describe("Move модель для файла.");
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/fileRenameDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const fileRenameDtoSchema = z.object({
	id: z.uuid(),
	newName: z.string()
}).describe("Rename модель для файла.");
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/pdfDocumentRenameResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const pdfDocumentRenameResponseSchema = z.object({ fileMeta: z.union([fileMetaDtoSchema, z.null()]).optional() });
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/rename3Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const rename3Status200Schema = pdfDocumentRenameResponseSchema;
const rename3ResponseSchema = rename3Status200Schema;
const rename3DataSchema = fileRenameDtoSchema.describe("Rename модель для файла.");
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/resolveLatestFileMetasRequestDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const resolveLatestFileMetasRequestDtoSchema = z.object({ ids: z.array(z.uuid()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }) });
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/resolveLatestFileMetas3Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const resolveLatestFileMetas3Status200Schema = z.array(fileMetaDtoSchema);
const resolveLatestFileMetas3ResponseSchema = resolveLatestFileMetas3Status200Schema;
const resolveLatestFileMetas3DataSchema = resolveLatestFileMetasRequestDtoSchema;
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/pdfDocumentUpdateResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const pdfDocumentUpdateResponseSchema = z.object({ fileMeta: fileMetaDtoSchema });
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/update3Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const update3QueryProcessTaskSchema = z.enum([
	"CLASSIFIER_DATA",
	"DICTIONARY_DATA",
	"DOCUMENT",
	"DICTIONARY_CALC_COST",
	"DICTIONARY_CALC_CALENDAR",
	"BUILDING_MANAGEMENT",
	"KNOWLEDGE_BASE_DOCUMENT",
	"TASK_TRACKER_DEFAULT"
]).optional();
const update3Status200Schema = pdfDocumentUpdateResponseSchema;
const update3ResponseSchema = update3Status200Schema;
const update3DataSchema = z.object({
	document: z.instanceof(File),
	id: z.string()
}).optional();
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/pdfDocumentUploadResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const pdfDocumentUploadResponseSchema = z.object({ fileMeta: fileMetaDtoSchema });
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/upload3Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const upload3QueryProcessTaskSchema = z.enum([
	"CLASSIFIER_DATA",
	"DICTIONARY_DATA",
	"DOCUMENT",
	"DICTIONARY_CALC_COST",
	"DICTIONARY_CALC_CALENDAR",
	"BUILDING_MANAGEMENT",
	"KNOWLEDGE_BASE_DOCUMENT",
	"TASK_TRACKER_DEFAULT"
]).optional();
const upload3Status200Schema = pdfDocumentUploadResponseSchema;
const upload3ResponseSchema = upload3Status200Schema;
const upload3DataSchema = z.object({
	document: z.instanceof(File),
	parentId: z.string(),
	sourceId: z.string(),
	sourceType: z.string()
}).optional();
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/uploadWithPreviewSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const uploadWithPreviewQueryProcessTaskSchema = z.enum([
	"CLASSIFIER_DATA",
	"DICTIONARY_DATA",
	"DOCUMENT",
	"DICTIONARY_CALC_COST",
	"DICTIONARY_CALC_CALENDAR",
	"BUILDING_MANAGEMENT",
	"KNOWLEDGE_BASE_DOCUMENT",
	"TASK_TRACKER_DEFAULT"
]).optional();
const uploadWithPreviewStatus200Schema = pdfDocumentUploadResponseSchema;
const uploadWithPreviewResponseSchema = uploadWithPreviewStatus200Schema;
const uploadWithPreviewDataSchema = z.object({
	document: z.instanceof(File),
	parentId: z.string(),
	sourceId: z.string(),
	sourceType: z.string()
}).optional();
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/uploadFilesAsZipResponseDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const uploadFilesAsZipResponseDtoSchema = z.object({ fileMetaDtos: z.array(fileMetaDtoSchema) });
//#endregion
//#region src/__generated__/filesystem-gge/pdfDocument/zod/uploadZip3Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const uploadZip3Status200Schema = uploadFilesAsZipResponseDtoSchema;
const uploadZip3ResponseSchema = uploadZip3Status200Schema;
const uploadZip3DataSchema = z.object({
	document: z.instanceof(File),
	parentId: z.string(),
	sourceId: z.string(),
	sourceType: z.string()
}).optional();
//#endregion
export { getHighlightedAreaAsPdfPathFileIdSchema as $, move2Status200Schema as A, getPreviewsStatus200Schema as B, rename3DataSchema as C, delete3Status200Schema as Ct, fileRenameDtoSchema as D, pdfDocumentRenameResponseSchema as E, list3Status200Schema as F, getPageCountResponseSchema as G, pdfPreviewItemSchema as H, pdfDocumentListResponseSchema as I, getLatestFileMetas3DataSchema as J, getPageCountStatus200Schema as K, getPreviewsDataSchema as L, fileMoveDtoSchema as M, list3PathIdSchema as N, move2DataSchema as O, list3ResponseSchema as P, getHighlightedAreaAsPdfDataSchema as Q, getPreviewsPathFileIdSchema as R, resolveLatestFileMetasRequestDtoSchema as S, delete3ResponseSchema as St, rename3Status200Schema as T, pdfPreviewRequestSchema as U, pdfPreviewResponseSchema as V, getPageCountQueryFileIdSchema as W, getLatestFileMetas3Status200Schema as X, getLatestFileMetas3ResponseSchema as Y, getLatestFileMetasRequestDtoSchema as Z, update3Status200Schema as _, deleteMany3DataSchema as _t, uploadWithPreviewDataSchema as a, getHighlightedAreaAsImageStatus200Schema as at, resolveLatestFileMetas3ResponseSchema as b, deleteFileMetasRequestDtoSchema as bt, uploadWithPreviewStatus200Schema as c, getFileMetas3ResponseSchema as ct, upload3ResponseSchema as d, fileMetaDtoSchema as dt, getHighlightedAreaAsPdfResponseSchema as et, upload3Status200Schema as f, getCropBoxPathFileIdSchema as ft, update3ResponseSchema as g, pdfCropBoxDtoSchema as gt, update3QueryProcessTaskSchema as h, getCropBoxStatus200Schema as ht, uploadFilesAsZipResponseDtoSchema as i, getHighlightedAreaAsImageResponseSchema as it, pdfDocumentMoveResponseSchema as j, move2ResponseSchema as k, upload3DataSchema as l, getFileMetas3Status200Schema as lt, update3DataSchema as m, getCropBoxResponseSchema as mt, uploadZip3ResponseSchema as n, getHighlightedAreaAsImageDataSchema as nt, uploadWithPreviewQueryProcessTaskSchema as o, pdfAreaRequestSchema as ot, pdfDocumentUploadResponseSchema as p, getCropBoxQueryPageSchema as pt, pdfMetaResponseSchema as q, uploadZip3Status200Schema as r, getHighlightedAreaAsImagePathFileIdSchema as rt, uploadWithPreviewResponseSchema as s, getFileMetas3DataSchema as st, uploadZip3DataSchema as t, getHighlightedAreaAsPdfStatus200Schema as tt, upload3QueryProcessTaskSchema as u, getFileMetasRequestDtoSchema as ut, pdfDocumentUpdateResponseSchema as v, deleteMany3ResponseSchema as vt, rename3ResponseSchema as w, abstractDeleteResponseSchema as wt, resolveLatestFileMetas3Status200Schema as x, delete3PathIdSchema as xt, resolveLatestFileMetas3DataSchema as y, deleteMany3Status200Schema as yt, getPreviewsResponseSchema as z };

//# sourceMappingURL=uploadZip3Schema2.js.map